<template>
	<div class="feed">
		<section class="posts row">
			<div v-for="post in posts" class="post col-md-4 col-xs-12 post-wrapper">
				<md-card>
					<md-card-media class="post-header" :style="{'background-image': 'url(' + post.image + ')'}">
					</md-card-media>
					<md-card-header>
						<div class="md-title">{{post.title.rendered}}</div>
					</md-card-header>
					<md-card-content>
						<div v-html="post.excerpt.rendered"></div>
					</md-card-content>
					<md-card-actions>
						<a :href="post.link">{{$t("read_more")}}</a>
					</md-card-actions>
				</md-card>
			</div>
		</section>
    </div>
</template>

<script>
    import BlogService from '../services/BlogService'
	import downsize from 'downsize'
	import _ from 'lodash'

	const langTags = {
		"en": 8,
		"hu": 7
	}

	export default {
		data(){
			return {
                posts: []
            }
		},
		methods: {
			tagForLang(){
				return langTags[this.$i18n.locale] || langTags["en"];
			}
		},
		mounted(){
            BlogService.getPosts((err, posts) => {
				posts = _.filter(posts, p => {
					return _.includes(p.tags, this.tagForLang());
				});
				this.posts = _.map(_.take(posts,3), (post) => {
					var sizes = post.better_featured_image.media_details.sizes;
					if(sizes.large){
						post.image = sizes.large.source_url;
					}else if(sizes.medium){
						post.image = sizes.medium.source_url;
					}else{
						post.image = post.better_featured_image.source_url;
					}

					post.excerpt.rendered = downsize(post.excerpt.rendered,{"words": 30, "append": "..."});
					return post;
				});
			});
		}
	}
</script>

<style scoped lang="scss">
	.posts{
		align-items: flex-start;
		padding: 0;
        margin: 16px 8px;
		
        .post{
            margin-bottom: 16px;
        }

        .post .md-title{
			font-size: 20px;
			line-height: inherit;
		}
		
        .post-header{
			height: 200px;
			background-size: cover;
			background-position: center;
		}
	}

	.md-card .md-card-media + .md-card-header {
		padding: 8px 0 8px 8px;
		/* margin-top: -48px; */
		margin-bottom: -8px;
		background-color: rgba(255, 255, 255, 0.7);
		z-index: 100;
		line-height: auto;
	}

	.md-card .md-card-header + .md-card-content {
		padding: 0 8px;
	}

	.md-card .md-card-actions {
		margin-top: -8px;
		text-align: center;
		display: block;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// FeedView.vue?4adde8c0